const DB_CONNECTION_ERROR_PATTERNS = [
  "password authentication failed",
  "connection refused",
  "ECONNREFUSED",
  "connect ETIMEDOUT",
  "no pg_hba.conf entry",
  "could not connect",
  "Connection terminated",
  "server closed the connection unexpectedly",
  "the database system is starting up",
  "the database system is shutting down",
] as const;

const DB_CONNECTION_ERROR_REGEX = new RegExp(
  DB_CONNECTION_ERROR_PATTERNS.map((pattern) => pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|"),
  "i",
);

const MAX_ERROR_CAUSE_DEPTH = 8;

function collectErrorMessages(
  error: unknown,
  messages: string[] = [],
  seen = new Set<unknown>(),
  depth = 0,
): string[] {
  if (depth > MAX_ERROR_CAUSE_DEPTH) return messages;
  if (error instanceof Error) {
    messages.push(error.message);
    const record = error as { code?: unknown; errno?: unknown };
    if (typeof record.code === "string") messages.push(record.code);
    if (typeof record.errno === "string") messages.push(record.errno);
    if (!seen.has(error)) {
      seen.add(error);
      if (error.cause && error.cause !== error) collectErrorMessages(error.cause, messages, seen, depth + 1);
    }
    return messages;
  }
  if (typeof error === "string") {
    messages.push(error);
    return messages;
  }
  if (error && typeof error === "object") {
    if (seen.has(error)) return messages;
    seen.add(error);
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string") messages.push(message);
    const code = (error as { code?: unknown }).code;
    const errno = (error as { errno?: unknown }).errno;
    if (typeof code === "string") messages.push(code);
    if (typeof errno === "string") messages.push(errno);
    const cause = (error as { cause?: unknown }).cause;
    if (cause && cause !== error) collectErrorMessages(cause, messages, seen, depth + 1);
  }
  return messages;
}

export function describeDbConnectionError(error: unknown): string {
  return collectErrorMessages(error).filter(Boolean).join("\n");
}

export function isDbConnectionError(error: unknown): boolean {
  return DB_CONNECTION_ERROR_REGEX.test(describeDbConnectionError(error));
}
